var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { get } from "../../http.mjs";
import { orderFromStripePaymentIntentResponseSchemaV2 } from "../../psp/stripe/schema.mjs";
import { logger } from "../../log.mjs";
import { mapStripeErrorCode } from "../../psp/stripe/errors.mjs";
import { billingAddressElementId, expressCheckoutElementId, initializeStripeElements, paymentElementId, shippingAddressElementId } from "./elements.mjs";
export const initializeStripeIfNeeded = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    yield checkForPaymentIntentRedirect(state, actions);
    const cartCheckout = state.checkout;
    if (!cartCheckout) {
        return;
    }
    const cartPayment = cartCheckout === null || cartCheckout === void 0 ? void 0 : cartCheckout.payment;
    if ((cartPayment === null || cartPayment === void 0 ? void 0 : cartPayment.$type) !== 'stripeCheckout') {
        removeStripeElementsIfNeeded(state);
        return;
    }
    if (cartPayment.elements.status.$type === 'complete') {
        removeStripeElementsIfNeeded(state);
        actions.clearCartAndShowOrderConfirmation(cartPayment.elements.status.orderId);
        return;
    }
    yield addStripeElementsIfNeeded(state);
    yield initializeStripeElements(state, actions, cartCheckout, cartPayment);
});
const checkForPaymentIntentRedirect = (state, actions) => __awaiter(void 0, void 0, void 0, function* () {
    const url = new URL(window.location.href);
    const paymentIntentId = url.searchParams.get('payment_intent');
    const redirectStatus = url.searchParams.get('redirect_status');
    if (paymentIntentId && redirectStatus !== null) {
        url.searchParams.delete('redirect_status');
        url.searchParams.delete('payment_intent');
        url.searchParams.delete('payment_intent_client_secret');
        window.history.pushState({}, '', url);
        try {
            const response = yield get(`/stripe/payments/intents/v2/${paymentIntentId}`, state.checkoutApiBaseUrl, orderFromStripePaymentIntentResponseSchemaV2, state.token);
            switch (response.status) {
                case 'orderCreated':
                    actions.clearCartAndShowOrderConfirmation(response.orderId);
                    break;
                case 'chargeFailed': {
                    const { code, message } = response.error;
                    state.onUnexpectedError(message, { errorType: code ? mapStripeErrorCode(code) : 'unknown' });
                    break;
                }
                default:
                    break;
            }
        }
        catch (error) {
            switch (error.status) {
                case 401:
                    logger.error({ error }, 'Payment intent not authorised');
                    // TODO: raise a more specific error and make sure a2 handles it properly
                    // state.onUnexpectedError('Payment intent not authorised');
                    break;
                case 404:
                    logger.error({ error }, 'Failed to find order associated with payment intent');
                    break;
                default:
                    logger.error({ error }, 'An unknown error occurred when fetching order from payment intent');
                    state.onUnexpectedError('An unknown error occurred when fetching order from payment intent');
                    break;
            }
        }
    }
});
const addStripeElementsIfNeeded = (state) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { stripeCheckoutSet, stripeExpressSet } = stripeElementsAreSet(state);
    const shouldSetExpress = expressCheckoutAllowed(state) && !stripeExpressSet;
    if (!stripeCheckoutSet || shouldSetExpress) {
        state.update({
            checkoutElements: Object.assign(Object.assign({}, state.checkoutElements), { takeover: Object.assign(Object.assign({}, (((_a = state.checkoutElements.takeover) === null || _a === void 0 ? void 0 : _a.type) === 'partial' ? state.checkoutElements.takeover : {})), { type: 'partial', paymentElementId: paymentElementId, shippingAddressElementId: shippingAddressElementId, billingAddressElementId: billingAddressElementId }), express: {
                    payNowElementId: expressCheckoutAllowed(state) ? expressCheckoutElementId : undefined,
                } }),
        });
    }
});
// We only allow express checkout if we know your postal code
// because otherwise we can't calculate the correct prices
const expressCheckoutAllowed = (_state) => {
    // const validPostalCode = state.customer.address?.postalCode?.trim().length;
    // return !!validPostalCode && state.validCountryCode && state.validCurrency;
    // TODO: Stripe - For now we disable the stripe express checkout
    return false;
};
const removeStripeElementsIfNeeded = (state) => __awaiter(void 0, void 0, void 0, function* () {
    const { stripeCheckoutSet, stripeExpressSet } = stripeElementsAreSet(state);
    if (stripeCheckoutSet || stripeExpressSet) {
        state.update({
            checkoutElements: Object.assign(Object.assign({}, state.checkoutElements), { takeover: undefined, express: undefined }),
        });
    }
});
const stripeElementsAreSet = (state) => {
    var _a, _b;
    return {
        stripeCheckoutSet: ((_a = state.checkoutElements.takeover) === null || _a === void 0 ? void 0 : _a.type) === 'partial' &&
            state.checkoutElements.takeover.paymentElementId === paymentElementId &&
            state.checkoutElements.takeover.shippingAddressElementId === shippingAddressElementId &&
            state.checkoutElements.takeover.billingAddressElementId === billingAddressElementId,
        stripeExpressSet: ((_b = state.checkoutElements.express) === null || _b === void 0 ? void 0 : _b.payNowElementId) === expressCheckoutElementId,
    };
};
//# sourceMappingURL=index.js.map